<div class="agpr-subscription">
    <div
        *ngIf="hasQuota"
        [ngClass]="{ 'agpr-subscription-options': !isSocial }"
    >
        <div class="agpr-columns" *ngIf="quota$ | async as quota">
            <div class="agpr-column">
                <agpr-number-input
                    id="socialPreferences_quota_max"
                    [(ngModel)]="quota.maxCount"
                    [disabled]="disableInputs"
                    (ngModelChange)="calculateRemainingQuota(quota)"
                    label="AMT.subscriptions.quota.mentionQuota"
                    [integerOnly]="true"
                    [min]="0"
                    [max]="2000000000"
                ></agpr-number-input>
                <agpr-number-input
                    id="socialPreferences_quota_additional"
                    [(ngModel)]="quota.additionalCount"
                    [disabled]="disableInputs"
                    (ngModelChange)="calculateRemainingQuota(quota)"
                    label="AMT.subscriptions.quota.additionalQuota"
                    [integerOnly]="true"
                    [min]="0"
                    [max]="2000000000"
                ></agpr-number-input>
            </div>
            <div class="agpr-column">
                <agpr-text-input
                    id="socialPreferences_quota_used"
                    [(ngModel)]="quota.currentCount"
                    label="AMT.subscriptions.quota.usedQuota"
                    [disabled]="true"
                ></agpr-text-input>
                <agpr-text-input
                    id="socialPreferences_quota_remaining"
                    [(ngModel)]="remainingQuota"
                    label="AMT.subscriptions.quota.remainingQuota"
                    [disabled]="true"
                ></agpr-text-input>
            </div>
        </div>
    </div>
</div>
